<template>
  <h1>Subscription Card</h1>
</template>

<script>
export default {
  name: "SubscriptionCard",
};
</script>

<style scoped></style>
